import styled from 'styled-components';

//container principal; Margem top topbar xxx
export const Container = styled.div``;
